export default "__VITE_ASSET__81422365__"